import React from "react";
import { Modal, Button } from "react-bootstrap";
import "react-toastify/dist/ReactToastify.css";

const TeacherSubjectClassDetailsModal = ({ show, handleClassSubjectModalClose, teacherClassSubjectData }) => {
  
  if (!teacherClassSubjectData) {
    return null; // Show nothing if teacher details are not yet loaded
  }

  return (
    <Modal
      show={show}
      onHide={handleClassSubjectModalClose}
      dialogClassName="custom-modal-md"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Class & Subject Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
      <table className="table table-bordered table-striped">
            <thead className="thead-dark">
              <tr>
                <th>Class</th>
                <th>Section</th>
                <th>Stream</th>
                <th>Subject</th>
                <th>Is Class Teacher</th>
              </tr>
            </thead>
            <tbody>
              {teacherClassSubjectData.map((item, index) => (
                <tr key={item.id || index}>
                  <td>{item.class}</td>
                  <td>{item.section}</td>
                  <td>{item.stream}</td>
                  <td>{item.subject}</td>
                  <td>{item.isClassTeacher === 1 ? "Yes" : "No"}</td>
                </tr>
              ))}
            </tbody>
          </table>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClassSubjectModalClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default TeacherSubjectClassDetailsModal;
